import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
export const IsSupportingContentCheckbox = ({
  isSupportingContentChecked,
  onChange
}) => {
  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: isSupportingContentChecked,
    onChange: onChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.isSupportingCheckbox"
    })
  });
};